import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from 'src/environments/environment';
import {EnvService} from '../../../core/services/env.service';

@Component({
  selector: 'app-sso-login-warning',
  templateUrl: './sso-login-warning.component.html',
  styleUrls: ['./sso-login-warning.component.scss']
})
export class SsoLoginWarningComponent implements OnInit {
  private readonly ssoLink: string;
  constructor(
    public dialogRef: MatDialogRef<SsoLoginWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private env: EnvService
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.ssoLink = env.sme_portal_url + '/login';
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onConfirmClick() {
    this.dialogRef.close(this.ssoLink);
  }

}
